// Modal de confirmación para cerrar la fase de oferta ciega
import React from 'react';
import { AlertTriangle, EyeOff } from 'lucide-react';
import BaseModal from './BaseModal';

const CloseBlindBiddingModal = ({ property, onConfirm, onCancel }) => {
  return (
    <BaseModal
      onClose={onCancel}
      title="Cerrar Fase Ciega"
      icon={<EyeOff className="w-5 h-5 lg:w-6 lg:h-6 text-red-400" />}
      iconBg="bg-red-500/20"
      borderColor="border-red-500/30"
      maxWidth="lg:max-w-md"
      responsive
      footer={
        <>
          <button
            onClick={onCancel}
            className="flex-1 bg-slate-700 text-white font-medium py-2 lg:py-3 rounded-lg hover:bg-slate-600 transition-all text-sm lg:text-base"
          >
            Cancelar
          </button>
          <button
            onClick={onConfirm}
            className="flex-1 bg-gradient-to-r from-red-500 to-red-600 text-white font-semibold py-2 lg:py-3 rounded-lg hover:from-red-600 hover:to-red-700 transition-all text-sm lg:text-base"
          >
            Cerrar Fase Ciega
          </button>
        </>
      }
    >
      <div className="bg-red-500/10 border border-red-500/20 rounded-lg p-4 flex items-start gap-3">
        <AlertTriangle className="w-5 h-5 text-red-400 flex-shrink-0 mt-0.5" />
        <div className="flex-1">
          <p className="text-sm text-red-200 mb-2">
            <strong>¿Cerrar la fase de oferta ciega?</strong>
          </p>
          <p className="text-xs text-red-300/80">
            Esta acción finalizará el período de ofertas ciegas para esta propiedad.
          </p>
        </div>
      </div>

      <div className="bg-slate-700/30 rounded-lg p-4">
        <p className="text-white font-semibold text-center text-sm lg:text-base">
          {property.title}
        </p>
      </div>

      <div className="text-xs lg:text-sm text-slate-400 space-y-2">
        <p className="font-medium text-slate-300">Al cerrar la fase ciega:</p>
        <p>• Se finalizará el período de ofertas confidenciales</p>
        <p>• No se podrán recibir más ofertas ciegas</p>
        <p>• Podrás abrir la subasta abierta cuando estés listo</p>
      </div>
    </BaseModal>
  );
};

export default CloseBlindBiddingModal;
